module.exports = __webpack_public_path__ + "img/my_page_active.ed806f85.svg";